<template>
    <div class="border-b border-white border-opacity-10">
        <button type="button" class="flex items-center justify-between text-white w-full py-8 px-8" @click="toggleCollapse">
            <span>{{ title }}</span>
            <AtomIcChevron :width="15" :height="14" class="transition ease-in-out duration-200" :class="{ 'rotate-180': isCollapsed }"/>
        </button>

        <div :class="{ 'collapsed': isCollapsed }" class="collapse-transition px-8">
            <slot name="default" />
        </div>
    </div>
</template>

<script>
import AtomIcChevron from "../atoms/AtomIcChevron.vue";

export default {
    name: 'MoleculeCollapse',
    components: {AtomIcChevron },
    props: {
        title: {
            type: String,
            default: ""
        },
        defaultCollapse: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            isCollapsed: true,
        };
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
    },
    mounted() {
        this.isCollapsed = this.defaultCollapse
    },
}
</script>

<style scoped>
.collapse-transition {
    max-height: 500px;
    transition: max-height 0.2s ease-in-out;
}

.collapsed {
    max-height: 0;
    overflow: hidden;
}
</style>

